import { useEffect, useState } from "react"

export default function useDebounce(value, delayMs = 300) {
    const [debounced, setDebounced] = useState(value)

    useEffect(() => {
        const handle = setTimeout(() => setDebounced(value), delayMs)
        return () => clearTimeout(handle)
    }, [value, delayMs])

    return debounced
}
